/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import Trash from "@/assets/trash.svg";
import {TextArea} from "@/components/Atoms";
import InputLabel from "@/components/Atoms/InputLabel";
import {useResponseId,useUrlType} from "@/components/hooks";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave,useUpdateAnswersSubmit} from "@/state/survey/saveAnswerSlice";
import {Utility,Validate} from "@/utils";
import React,{useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";

const CommentNode = (props:any) => {
    const { node, disabled, name, repeatedElement=false, onBlur } = props;
    //const { currentPage} = useSelector((state:RootState) => state.patientSurvey);
    const [addComment, setAddComment] = useState<boolean>(false)
    const form = useSelector((state:RootState) => state.form);
    const { state = {} } = form[node.name];
    const [questionName, setQuestionName] = useState('') 
    const {answerResponseId} = useResponseId();
    const validateInputField = useValidate();
    const {isPatient} = useUrlType();
    const hasExecuted = useRef(false);
    const updateAnswersDispatch = useUpdateAnswersSubmit();
    const [ deleteIconStatus, setDeleteIconStatus ] = useState<string>()

    useEffect(()=>{
        if(form[node.name].value){
            setAddComment(true);
        }
    },[form, setAddComment, node])


    const handleChange = (value: string, name: string) => {
        validateInputField(name, value, true);
        if(node.validationDependants) {
            node.validationDependants.forEach((element : string)=> {
                validateInputField(element, form[element].value, true);
            });
        }
    }
    useEffect(()=>{
        if(node) {
            const deleteConfig: string | null | undefined = Utility.getValueFromKey(node, 'ShowDelete');

            setDeleteIconStatus(deleteConfig as string);
        }

    },[node]);

    const handleAddComent = (vlaue: boolean) =>{
        setAddComment(vlaue)
    }

    const handleRemoveComent =() => {
        setAddComment(false);
        validateInputField(node.name, '', true);
        const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormatFromValue('',node )
        updateAnswersDispatch(answers, answerResponseId as number);
    }

    const handleOnBlur = () => {
        if(!isPatient && answerResponseId && !repeatedElement ) {
            const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormat(form,node )
            updateAnswersDispatch(answers, answerResponseId);
        } 
        if(repeatedElement && onBlur) 
            onBlur()

    }

    useEffect(()=>{
        if(!isPatient && name && form[node.name] && questionName != name && !hasExecuted.current){ //poa only
            validateInputField(name, form[node.name].value, true);
            setQuestionName(name)
            hasExecuted.current = true;
        }
    }, [form, questionName, node, isPatient, name,validateInputField ])
    
//ShowDelete
    return (<React.Fragment>
        {disabled && !isPatient && !form[node.name].value ? null : <React.Fragment>
            <div className={`comment-wrap ${Utility.getClassForWidthPx(node)}  ${Utility.getClassForWidth(node)} user-input poa-comment ${!isPatient ? 'poa-input': '' } input-border-top`}>
        { addComment ? 
        (
            <div>               
                <InputLabel label={node.title} labelClasses="input-label add-comment-input-area"></InputLabel>
                <div className="flex">
                <TextArea  onBlur={handleOnBlur}   form={form}  disabled={disabled} isInValid = {Validate.isInvalid(state)} name={node.name} value={form[node.name].value as string} onChange={handleChange} propClasses={`textarea-input input-border ${disabled ? 'disabled' : ''}`}/>
               {!repeatedElement && !(deleteIconStatus && deleteIconStatus === "false") ? <div onClick={ () => {handleRemoveComent()}} className="flex comment-remove-icon"><img src={Trash} style={{ display: disabled ? 'none' : 'block' }}/></div> : ''} 
                </div>
            </div>
        ) : 
            ( !disabled && <div className="add-link-poa flex"><button style={{ color:'#147BC2'}} className="link-blue" type="button" onClick={ () => handleAddComent(true)}>{node.title} +</button></div>)
        }
    </div>
            </React.Fragment>}

   
    </React.Fragment>
  
        
    )
}

export default CommentNode;